module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/gillian-walker-4244e42ac8d81b437fd5645b4472ef84.jpg";